import React from 'react';

// location is the percentage of the dot that goes in the bar, from 0 to 1.
export default function PositionBar({ location }) {
  let percentage = 0;
  let isNegative = false;
  let isZero = false;
  let position = 0;
  let show = false;

  try {
    const resh = stringToPercentage(location);

    if (resh !== null) {
      show = true;

      let [p, n, z] = resh;

      percentage = p;
      isNegative = n;
      isZero = z;

      const center = 50;

      const maxPercentage = 1;

      const percentageForHalfBar =
        Math.abs(percentage >= 1 ? maxPercentage : percentage) / 2;

      position = isNegative
        ? center - percentageForHalfBar * 100
        : center + percentageForHalfBar * 100;
    }
  } catch (error) {
    console.error('Error parsing location', error);
  }

  return (
    <div className="relative h-2 w-24 bg-[#E8ECE6] rounded-full n">
      <div className="w-0.5 rounded-sm h-3.5 bg-[#E8ECE6] absolute top-[50%] translate-y-[-50%] z-20 left-[50%] translate-x-[-50%]"></div>
      {percentage !== null && show && (
        <div
          className={`absolute h-2 w-0.5 translate-x-[-50%] z-30 ${
            isNegative
              ? 'bg-[#E5844F]'
              : isZero
              ? 'bg-neutral-500'
              : 'bg-primary-500'
          }`}
          style={{ left: `${position}%` }}
        ></div>
      )}
    </div>
  );
}

function stringToPercentage(percStr) {
  if (typeof percStr !== 'string') {
    return null;
  }

  if (!percStr.endsWith('%')) {
    return null;
  }
  const value = parseFloat(percStr.slice(0, -1));

  const isNegative = value < 0;
  const isZero = value === 0;

  const percentage = Math.abs(value);
  return [percentage / 100, isNegative, isZero];
}
